import { Award, Search, Handshake, Network } from 'lucide-react';
import { IMAGES } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const ICONS = [Award, Search, Handshake, Network];

export default function WhyUs() {
  const { t } = useLang();
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="lg:sticky lg:top-32">
            <span className="section-label mb-4">{t('whyUs.label')}</span>
            <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mt-4 mb-6 leading-tight">
              {t('whyUs.title1')} <span className="yellow-underline">{t('whyUs.title2')}</span>
            </h2>
            <p className="text-gray-600 leading-relaxed mb-8">{t('whyUs.intro')}</p>
            <img src={IMAGES.containers} alt="" className="rounded-lg w-full h-64 object-cover shadow-xl" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {t('whyUs.items').map((w, i) => {
              const Icon = ICONS[i];
              return (
                <div key={i} className="p-6 rounded-xl border border-gray-100 bg-gray-50 hover-lift hover:border-brand-yellow hover:bg-white">
                  <div className="w-12 h-12 rounded-lg bg-brand-navy flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-brand-yellow" />
                  </div>
                  <h3 className="text-lg font-bold text-brand-navy mb-2">{w.t}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{w.d}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
